<template>
  <div>
    <div @click="Go2Top()" class="GoTop">
      <div
        v-if="visible"
        style="border: 1px solid  rgb(48, 133, 214);background-color:white;height:40px;width:40px;margin-right:5px;border-radius: 40px;line-height:40px;text-align:center"
      >
        <v-icon style="color: rgb(48, 133, 214);line-height:38px">expand_less</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations, commit } from 'vuex'
import axios from 'axios'

import PullTo from 'vue-pull-to'

// util
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import dateHelper from '../util/date'
import { obtainImage } from '../util/image'
import {
  encryptGPS,
  getBaseGPS,
  isAmapExist,
  startAmap,
  isBaiduMapExist,
  startBaiduMap,
  StaticMap,
} from '../util/location'

export default {
  name: 'iDS-GoTop',
  data: function () {
    return {
      /**
       * 用来管理DOM(scroll-container)的scroll
       */
      scroll: null,

      /**
       * 控制该组件是否可见
       */
      visible: false,
    }
  },
  methods: {
    Go2Top() {
      // debugHelper.log("返回顶部")
      this.scroll.scrollTop = 0
    },
  },
  computed: {
    isNeed() {
      // 如果该this.scroll有向下滑动, 那么就需要显示该组件
      if (this.scroll == null) {
        return false
      }
      // debugHelper.log("hello")
      if (this.scroll.scrollTop >= this.scroll.clientHeight) {
        return true
      } else {
        return false
      }
    },
  },

  mounted: function () {
    // 挂载时选中scroll-container(由pull-to组件生成)
    this.scroll = document.getElementsByClassName('scroll-container')[0]

    // 监听滚动事件
    this.scroll.addEventListener('scroll', () => {
      // debugHelper.log("testForScroll")
      if (this.scroll.scrollTop > 0) {
        this.visible = true
      } else {
        this.visible = false
      }
    })
  },
  beforeDestroy() {},
}
</script>

<style >
.GoTop {
  transform: translate3d(0, 0, 0);
  position: fixed;
  float: right;
  z-index: 1000;
  bottom: 6rem;
  right: 10px;
  margin: 0;
  padding: 0;
}
</style>
